import React, { Component } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import ProtectedRoute from './ProtectedRoute';
import Error404 from '../common/error404';
import App from '../../App';
import { RC_LOAD_APP, ACCOUNT_FILE, RC_LOAD_LOGIN, ADDITIONAL_ACCOUNT_INFO, CARRIER, REPORTS_BASE_URL, REPORTS_BALANCE, REPORTS_MAIN, ROUTING_BASE_URL, CALL_RESTRICTION, ROUTING_URL, REPORTS_ACCOUNT_STATS, REPORTS_CARRIER_STATS, CARRIER_INFO, CDR_BILLING, AGENT_SECTION, ADD_RATEDECK_URL, LISTING_RATEDECK, RATEDECK_BASE_URL, ACCOUNT_DASHBOARD, CARRIER_DASHBOARD, ADD_ACCOUNT_INFORMATION, USER_URL, INVOICE_BASE_URL, INVOICE_AGENT_BASE_URL, CREATE_RATEDECK_URL, FIND_ROUTE_URL, ACCOUNTS_PER_DAY, CARRIER_PER_DAY, ACCOUNT_CREATE, SUBJECT_BLOCK, MEDIA_ROUTING_URL, REPORTS_ACCOUNT_REJECTION, REPORTS_TRAFFIC_STATS } from './RouteConstants';
import Accounts from '../Accounts/account';
import Login from '../Authentication/loginComp';
import AdditionalAccountInfo from '../Additinal-Account-info/additionalAccount';
import CarrierIndex from '../carrier';
import MainReport from '../reports/main-report';
import ReportBalance from '../reports/balance-report';
import CallRestriction from '../Routing-page/callRestriction';
import MainRouting from '../Routing-page/mainRouting';
import AccountStatsReport from '../reports/accountStatsReport';
import CarrierStatsReport from '../reports/carrierStatsReport';
import AccountRejectionReport from '../reports/accountRejectionReport';
import componentTabs from '../carrier/componentTabs';
import CdrBilling from '../Billing/cdrBilling';
import AgentTable from '../Additinal-Account-info/components/agentSection/agentTable';
import AgentMainTable from '../AgentsList/agentTable';
import RateDeckIndex from '../RateDeck/listingPage';
import RateDeckListing from '../RateDeck/listingPage';
import RateDeckAddForm from '../RateDeck/addForm';
import DashboardTable from '../Accounts/dashboard/dashboardTable';
import CarrierDashboard from '../carrier/dashboard/carrierDashboard';
import InvoiceIndex from '../invoice/index';
import AgentInvoiceIndex from '../agentInvoice';
import CreateRateDeckIndex from '../Route';
import FindRouteIndex from '../Route/findRoutePage';
import AccountPerDay from '../reports/perDayStats/accountStatsPerDay';
import CarrierPerDay from '../reports/perDayStats/carrierStatsPerDay'
import AddAccountPage from '../Accounts/addAccountPage';
import StirShakenSubjectBlock from '../stirShakenSubjectBlock';
import mediaIpBlock from '../Route/mediaIpBlock';
import TrafficStatsReport from '../reports/trafficStatsReport';



class AllRoutes extends Component {
   
    render() {
        
        return (
            <BrowserRouter>
               
                    <Switch>

                        <Route exact path={RC_LOAD_LOGIN} component={Login} />

                        <ProtectedRoute exact path={RC_LOAD_APP} component={App} />
                        <ProtectedRoute exact path={ACCOUNT_FILE} component={Accounts} />
                        <ProtectedRoute exact path={ACCOUNT_CREATE} component={AddAccountPage} />
                        <ProtectedRoute exact path={ACCOUNT_DASHBOARD} component={DashboardTable} />
                        {/* <ProtectedRoute exact path={ADD_ACCOUNT_INFORMATION} component={AddingAccountInfoIndex} /> */}


                        <ProtectedRoute exact path={CARRIER} component={CarrierIndex} />
                        <ProtectedRoute exact path={CARRIER_DASHBOARD} component={CarrierDashboard} />

                        <ProtectedRoute exact path={REPORTS_BALANCE} component={ReportBalance} />
                        <ProtectedRoute exact path={REPORTS_ACCOUNT_STATS} component={AccountStatsReport} />
                        <ProtectedRoute exact path={REPORTS_CARRIER_STATS} component={CarrierStatsReport} />
                        <ProtectedRoute exact path={REPORTS_ACCOUNT_REJECTION} component={AccountRejectionReport} />
                        <ProtectedRoute exact path={REPORTS_TRAFFIC_STATS} component={TrafficStatsReport} />
                        <ProtectedRoute exact path={REPORTS_MAIN} component={MainReport} />

                        <ProtectedRoute exact path={AGENT_SECTION} component={AgentMainTable} />

                        <ProtectedRoute exact path={SUBJECT_BLOCK} component={StirShakenSubjectBlock} />

                        <ProtectedRoute exact path={CDR_BILLING} component={CdrBilling} />

                        <ProtectedRoute exact path={CALL_RESTRICTION} component={CallRestriction} />
                        <ProtectedRoute exact path={MEDIA_ROUTING_URL} component={mediaIpBlock} />

                    

                        <ProtectedRoute exact path={RATEDECK_BASE_URL} component={RateDeckListing} />
                        <ProtectedRoute exact path={INVOICE_BASE_URL} component={InvoiceIndex} />

                        <ProtectedRoute exact path={INVOICE_AGENT_BASE_URL} component={AgentInvoiceIndex} />

                        <ProtectedRoute exact path={CREATE_RATEDECK_URL} component={CreateRateDeckIndex} />
                        <ProtectedRoute exact path={FIND_ROUTE_URL} component={FindRouteIndex} />

                        <ProtectedRoute Route path={`${ADDITIONAL_ACCOUNT_INFO}/:id/:accountName/:type`} component={AdditionalAccountInfo} />
                        <ProtectedRoute Route path={`${CARRIER_INFO}/:id/:name`} component={componentTabs} />
                        <ProtectedRoute Route path={`${ACCOUNTS_PER_DAY}/:id/:name`} component={AccountPerDay}  />
                        <ProtectedRoute Route path={`${CARRIER_PER_DAY}/:id/:name`} component={CarrierPerDay}  />
                        <ProtectedRoute Route path={`${USER_URL}/:id`} />
                        <ProtectedRoute path="*" component={Error404} />
                    </Switch>
                   
            </BrowserRouter>
        )
    }
}

export default AllRoutes